import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import MessageType from '../../../../enums/MessageType';
import {hidePudoCollectionPoints} from '../../../actions/pudo-actions';
import Translation from '../../../lang/Translation';
import {getSettings} from '../../../selectors/selectors';
import CollectionNewCollectionPointLazyLoader
from '../../Collection/CollectionPoint/CollectionNewCollectionPointLazyLoader';
import NewCollectionOverlayBodyLazyLoader from '../../NewCollection/NewCollectionOverlayBodyLazyLoader';
import Message from '../../ui/Message/Message';
import CheckoutOverlay from '../CheckoutOverlay';

export function CollectionOverlay(props) {
  const shouldNotLoadPUDO = document.documentMode !== undefined;
  
  const getInfoMessage = () => (
    <Message type={MessageType.INFO}>
      <Translation>pudo.not.supported</Translation>
    </Message>
  );
  
  return (
    <CheckoutOverlay
      autosize
      nopadding
      exitCallback={props.hidePudoCollectionPoints}
      isCollection
    >
      {/* eslint-disable-next-line no-nested-ternary */}
      {shouldNotLoadPUDO ? (
        getInfoMessage()
      ) : (
        props.shouldUseNewCollectionOverlay
          ? (
            <NewCollectionOverlayBodyLazyLoader />
          ) : (
            <CollectionNewCollectionPointLazyLoader />
          )
      )}
    </CheckoutOverlay>
  );
}

CollectionOverlay.propTypes = {
  hidePudoCollectionPoints: PropTypes.func.isRequired,
  shouldUseNewCollectionOverlay: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  shouldUseNewCollectionOverlay: !!getSettings(state)?.should_use_new_collection_overlay,
});

export default connect(mapStateToProps, {hidePudoCollectionPoints})(CollectionOverlay);
